import { render } from "./add-question.vue?vue&type=template&id=158b2bbb&lang=pug"
import script from "./add-question.vue?vue&type=script&setup=true&lang=js"
export * from "./add-question.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__